<template>
  <div>
    <div class="loader-fullscreen card" v-if="!user.role">
      <div class="card-body">
        <LoaderRelative />
        <div class="loader-messages">
          <span v-if="!addressBookReady && !chatReady">Lade Chat</span>
          <span v-if="!addressBookReady && chatReady">Lade Adressbuch</span>
          <span v-if="addressBookReady && chatReady">Erstelle Ansicht</span>
        </div>
      </div>
    </div>
    <transition :enter-active-class="animations.standard.enter" :leave-active-class="animations.standard.leave" :name="animations.standard.name">
      <div class="row" v-if="ready">
        <div class="col call-chat-sidebar">
          <div class="card">
            <div class="card-body chat-body">
              <div class="chat-box">
                <!-- Chat left side Start-->
                <div class="chat-left-aside chat-menu custom-scrollbar first_chatbar">
                  <b-tabs nav-class="tabbed-card border-tab border-tab-primary custom-scrollbar" fill v-model="tabindex">
                    <b-tab class="material-border" title="Meine Dialoge" active>
                      <div class="people-list custom-scrollbar" id="people-list">
                        <ul class="list pointer" v-if="filteredDialogues.length">
                          <li
                            class="clearfix chatboxcon"
                            v-for="(chat, idx) in filteredDialogues"
                            :key="idx"
                            @click="selectCurrentChat(chat.id)"
                          >
                            <div v-if="chat !== undefined" class="userBoxCon">
                              <div class="seenByIcon" v-if="!checkIfSeen(chat)">
                                <feather type="alert-circle" class="infra-blue"></feather>
                              </div>
                              
                              <div class="userBox">
                                
                                <img class="rounded-circle user-image" :src="getAvatar(chat.kunde.id)" alt />
                                <div class="about">
                                  <div class="name">{{ chat.kunde.first_name }} {{chat.kunde.last_name}}</div>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </b-tab>
                    <b-tab class="material-border right-tab" title="Alle Dialoge" > 
                      <div class="search-container">
                    Suche: <input type="text" v-model="filterOtherDialoguesInput" />
                  </div>
                      <div class="people-list custom-scrollbar" id="people-list">
                        <ul class="list pointer" v-if="filteredOtherDialogues.length">
                          <li
                            class="clearfix chatboxcon"
                            v-for="(chat, idx) in filteredOtherDialogues"
                            :key="idx"
                            @click="showOtherDialogue(chat.id)"
                          >
                            <div v-if="chat !== undefined" class="userBoxCon">
                              <div class="seenByIcon" v-if="!checkIfSeen(chat)">
                                <feather type="alert-circle" class="infra-blue"></feather>
                              </div>
                              <div class="userBox">
                                <img class="rounded-circle user-image" :src="getAvatar(chat.kunde.id)" alt />
                                <div class="about">
                                  <div class="name">{{ chat.kunde.first_name }} {{ chat.kunde.last_name }}</div>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </b-tab>
                  </b-tabs>
                </div>
                <!-- Chat left side Ends-->
              </div>
            </div>
          </div>
        </div>
        <div class="col call-chat-body">
          <div class="chat empty-chat-msg" v-if="!currentChat.active">
            Kein Dialog ausgewählt
          </div>
          <div class="card" v-if="currentChat.active">
            <div class="card-body p-0">
              <div class="row chat-box">
                <!-- Chat right side start-->
                <div class="col pr-0 chat-right-aside">
                  <!-- chat start-->
                  <div class="chat">
                    <!-- chat-header start-->
                    <div class="chat-header clearfix">
                      <div class="chat-header-avatars">
                        <div v-for="(recipient, idx) in currentChat.chat.recipients" :key="idx" class="chat-header-avatar">
                          <img class="rounded-circle" :src="getAvatar(recipient)" alt />
                          <div class="about">
                            <div class="name">
                              {{ getName(recipient) }}
                              <!--<span class="font-primary f-12">Typing...</span>-->
                            </div>
                            <div class="status digits">{{ getRole(recipient) }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="moderator-buttons">
                        <div
                          class="add-subscriber-btn infra-blue moderator-btn"
                          @click="subscribe()"
                          v-if="currentChat.active == 'watching'"
                        >
                          <feather
                            type="plus"
                            size="40"
                            class="moderator-btn-icon"
                          ></feather>
                        </div>
                        <div
                          class="remove-subscriber-btn infra-blue moderator-btn"
                          @click="unsubscribe()"
                          v-if="currentChat.active == true"
                        >
                          <feather
                            type="minus"
                            size="40"
                            class="moderator-btn-icon"
                          ></feather>
                        </div>
                      </div>
                    </div>
                    <!-- chat-header end-->
                    <div class="chat-history chat-msg-box custom-scrollbar" ref="current_chat_container" @scroll="loadMoreScroll">
                      <loaderRelative class="load-more-loader" v-if="loadingMore" />
                      <ul v-if="currentMessagesLoaded">
                        <li v-for="(message, idx) in currentMessages" :key="idx" :class="{ clearfix: message.sender != user.id }">
                          <div
                            class="message"
                            :class="{
                              'my-message': message.sender == user.id,
                              'other-message': message.sender != user.id,
                              'pull-right': message.sender != user.id,
                            }"
                          >
                            <img
                              class="rounded-circle float-left chat-user-img img-30"
                              v-if="message.sender == user.id"
                              :src="getAvatar(user.id)"
                              alt
                            />
                            <img
                              class="rounded-circle float-right chat-user-img img-30"
                              v-if="message.sender != user.id"
                              :src="getAvatar(message.sender)"
                              alt
                            />
                            <div class="message-data">
                              <span class="message-data-time">{{ transformDate(message.created_on) }}</span>
                            </div>
                            {{ message.message }}
                          </div>
                        </li>
                        <div>
                          <div class="image-not-found">
                            <div class="d-block start-conversion">
                              <img class="img-fluid" />
                            </div>
                          </div>
                        </div>
                      </ul>
                    </div>
                    <!-- end chat-history-->
                    <div class="chat-message clearfix">
                      <div class="row">
                        <div class="col-xl-12 d-flex">
                          <div class="input-group text-box text-with-loader" v-if="currentChat.active === true">
                            <input
                              class="form-control input-txt-bx"
                              id="message-to-send"
                              type="text"
                              name="message-to-send"
                              placeholder="Nachricht schreiben..."
                              v-model="currentChat.newMessage"
                              
                              @focus="scrollToBottom"
                              v-focus
                              
                              :disabled="currentChat.updating"
                              autocomplete="off"
                            />
                            <div class="loader-container">
                              <Loader v-if="currentChat.updating" size="30" />
                            </div>
                            <div class="input-group-append">
                              <button ref="sendButton" class="btn btn-primary" type="button" @click="sendMessage()">
                                Senden
                              </button>
                            </div>
                          </div>                          
                        </div>
                      </div>
                    </div>
                    <!-- end chat-message-->
                    <!-- Chat right side-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/loader.vue";
import LoaderRelative from "@/components/LoaderRelative.vue";


export default {
  name: "chat_subscriber",
  data() {
    return {
      filterOtherDialoguesInput: "",
      filterDialoguesInput: "",
      user_dialogues: [],
      other_dialogues: [],
      filtering: false,
      selectedSubscribers: [],
      ready: false,
      themenOfUser: [],
      allUsers: [],
      currentChat: {
        chatMe: false,
        chat: false,
        updating: false,
        active: false,
        newMessage: "",
      },
      chatRefresh: null,
      currentMessagesLoaded: false,
      currentMessages: [],
      loadedMessagesByChat: [],
      lockRefresh: false,
      loadingMore: false,
      tabindex: 0,
      offSetBase: 5,
      addressExclusionList: [1, 81, 113, 122, 227, 226],
    };
  },
  components: {
    Loader,
    LoaderRelative,
  },
  computed: {
    ...mapGetters({
      animations: "app/animations",
      user: "auth/user",
      userImg: "auth/userImg",
      toasts: "app/toasts",
      chatActive: "chat/chatActive",
      chatReady: "chat/chatReady",
      activeChats: "chat/activeChats",
      activeChatUsers: "chat/activeChatUsers",
      userAddressBook: "chat/userAddressBook",
      avatars: "chat/avatars",
      addressBookReady: "chat/addressBookReady",
      dialogues: "chat/dialogues",
      isAdmin: "auth/isAdmin",
      unseen: "chat/unseenMessages",
      themen: "app/themen",
      admins: "chat/admins",
      mods: "chat/mods"
    }),
    filteredOtherDialogues: function() {
      if (this.filterOtherDialoguesInput == "") return this.other_dialogues;
      return this.other_dialogues.filter((ac) => {        
        let result = `${ac.kunde.first_name} ${ac.kunde.last_name}`.toLowerCase().includes(this.filterOtherDialoguesInput.toLowerCase());
        return result;
      });
    },
    filteredDialogues: function() {
      if (this.filterDialoguesInput == "") return this.user_dialogues;
      return this.user_dialogues.filter((ac) =>
        ac.kundeName.toLowerCase().includes(this.filterDialoguesInput.toLowerCase())
      );    
    },  
    assignedSubscribers: function() {
      if (!this.currentChat.chat) return;
      return this.admins.filter((adm) => {
        return this.currentChat.chat.recipients.find((rcp) => rcp == adm.id) != undefined;
      });
    },
    otherDialogues: function() {
      return this.dialogues.filter((d) => {
        return d.subscribers.find((s) => s.user_id == this.user.id) == undefined;
      });
    },
  },
  async created() {
    if (!this.themen) await this.$store.dispatch("app/apiGetThemen");
    if (!this.activeChats.length && !this.chatReady) {
      try {
        await this.$store.dispatch("chat/initChat");
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim initialisieren des Chat Systems.", this.toasts.failure);
      }
    }

    try {
      await this.$store.dispatch("chat/buildUserAddressBook");
      this.allUsers = [...this.userAddressBook.kunden, ...this.userAddressBook.infrabau];
    } catch (error) {
      console.log(error);
      this.$toasted.show("Fehler beim Laden des Addressbuchs", this.toasts.failure);
    }

    await this.$store.dispatch("chat/getAdminSubscribers");
    await this.checkDialogues();
    this.ready = true;
  },
  watch: {
    activeChats: function() {
      if (this.currentChat.chat == undefined) return;      
      this.refreshCurrentChat();
      this.checkDialogues();
    },
  },  
  methods: {
    async subscribe() {
      const userId = this.user.id;
      const chatId = this.currentChat.chat.id;
      await this.assignUserToDialogue(userId, chatId);   
      await this.$store.dispatch("chat/updateDialogues");   
      this.checkDialogues();
      this.tabindex = 0;
    },
    async unsubscribe() {
      const userId = this.user.id;
      const chatId = this.currentChat.chat.chat_id;
      await this.removeUserFromDialogue(userId, chatId);  
      await this.$store.dispatch("chat/updateDialogues");   
      this.checkDialogues(); 
      
    },
    async checkDialogues() {      
      const getUserDialogues = this.dialogues.filter(d => {return d.subscribers.find(s => s.user_id == this.user.id)});
      const getOtherDialogues = this.dialogues.filter(d => {return d.subscribers.find(s => s.user_id == this.user.id) == undefined});
      this.user_dialogues = getUserDialogues;
      this.other_dialogues = getOtherDialogues;
    },  
    async showSubscriberModal(modal) {
      if (!this.admins.length) await this.$store.dispatch("chat/getAdminSubscribers");
      this.$bvModal.show(modal);
    },
    hideSubscriberModal(modal) {
      this.$bvModal.hide(modal);
    },
    loadMoreScroll(evt) {
      if (evt.target.scrollTop == 0) {
        this.loadMoreCurrentChatMessages();
      }
    },
    checkIfSeen(chat) {
      if (!chat.seenby) return true;
      const result = chat.seenby.find((c) => c == this.user.id);
      return result;
    },
    isCustomer(usr) {
      const user = this.allUsers.find((u) => u.id == usr);
      return user.role == 3;
    },
    getName(id, shorten = false) {
      if (!this.allUsers.length) return;
      const user = this.allUsers.find((u) => u.id == id);
      const str = `${user.first_name} ${user.last_name}`;
      const formattedName = shorten ? str.substring(0, 20) : str;
      return formattedName;
    },
    getAvatar(id) {      
      const user = this.avatars.find((a) => a.usr_id == id);
      if (!user) return;
      return user.avatar.data.full_url;
    },
    getLastMessage(chatId, userId) {
      const theChat = this.activeChats.find((c) => c.chat_id == chatId);
      if (undefined == theChat) return;
      const lastMessage = theChat.messages.filter((m) => m.sender == userId);
      lastMessage.reverse();
      if (undefined !== lastMessage && lastMessage.length > 0) return lastMessage[0].message.substring(0, 20) + "..";
    },
    isActive(id) {
      const res = this.activeChatUsers.find((cu) => cu.usr_id == id) == undefined;
      return res;
    },
    isChatUser(id) {
      return this.addressExclusionList.indexOf(id) > -1 ? false : true;
    },
    async showOtherDialogue(chatId) {
      console.log("running showOtherDialogue for " + chatId);
      const dialogue = this.other_dialogues.find(d => d.id == chatId);
      const messages = dialogue.messages.map(m => m.nachricht_id);
      if(!dialogue) return;      
      this.currentChat.chatMe = this.user;      
      this.currentChat.chat = dialogue;
      this.currentChat.chat.messages = messages;
      this.currentChat.active = "watching";
      this.currentChat.newMessage = "";
      this.currentChat.chat.recipients = [];
      this.currentChat.chat.recipients = [
        dialogue.kunde.id,
        ...this.mods.map(m => m.user.id),
        ...dialogue.subscribers
      ];
      await this.loadCurrentChatMessages();
      this.scrollToBottom();
    },
    async selectCurrentChat(chatId) {
      const chat = this.activeChats.find((ac) => ac.chat_id == chatId);
      this.currentChat.chatMe = this.user;      
      this.currentChat.chat = chat;
      this.currentChat.active = true;
      this.currentChat.newMessage = "";
      this.currentChat.chat.recipients = [];
      this.currentChat.chat.recipients = [
        this.currentChat.chat.kunde.id,
        ...this.mods.map(m => m.user.id),
        ...chat.recipients
      ];
      const dialogue = this.dialogues.find((d) => d.id == chatId);
      const seenBy = dialogue.seenby ? dialogue.seenby : [];
      const isAlreadySeen = seenBy.find((s) => s == this.user.id);
      await this.loadCurrentChatMessages();
      this.scrollToBottom();
      if (!isAlreadySeen) {
        seenBy.push(this.user.id);
        const updatePayload = {
          dialogue: chatId,
          seenby: seenBy,
        };
        this.$store.dispatch("chat/setSeenByMe", updatePayload);
      }
    },
    async loadCurrentChatMessages() {
      const messagesLoaded = this.loadedMessagesByChat.find((chat) => chat.id == this.currentChat.chat.chat_id);

      if (!messagesLoaded) {
        const intialOffsetMessages = this.currentChat.chat.messages.slice(-this.offSetBase);
        const loadMessages = await this.$store.dispatch("chat/getMessagesOfDialogue", intialOffsetMessages);
        const newMessagesByChat = {
          id: this.currentChat.chat.chat_id,
          offSet: this.offSetBase,
          messages: loadMessages,
        };

        this.loadedMessagesByChat.push(newMessagesByChat);
        this.currentMessages = newMessagesByChat.messages;
        this.currentMessages.sort((a, b) => new Date(a.created_on) - new Date(b.created_on));
        this.currentMessagesLoaded = true;
      } else {
        this.currentMessages = messagesLoaded.messages;
      }
    },
    async loadNewChatMessages() {
      //check if new Messages
      if (!this.currentChat.chat) return;
      try {
        this.lockRefresh = true;
        const currentLenLoaded = this.currentMessages.length;
        if (!currentLenLoaded) return;
        const lastLoadedMessage = this.currentMessages[currentLenLoaded - 1].id;
        const currentLenStore = this.currentChat.chat.messages.length;
        const lastStoreMessage = this.currentChat.chat.messages[currentLenStore - 1];
        const newMessages = lastLoadedMessage != lastStoreMessage;

        if (newMessages) {
          const idxLast = this.currentChat.chat.messages.indexOf(lastLoadedMessage);
          const newMessages = this.currentChat.chat.messages.slice(idxLast + 1);
          const loadNewMessages = await this.$store.dispatch("chat/getMessagesOfDialogue", newMessages);
          const currentLoadedMessagesByChat = this.loadedMessagesByChat.find((chat) => chat.id == this.currentChat.chat.chat_id);
          currentLoadedMessagesByChat.messages.unshift(...loadNewMessages);
          currentLoadedMessagesByChat.messages.sort((a, b) => new Date(a.created_on) - new Date(b.created_on));
          this.scrollToBottom();
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.lockRefresh = false;
      }
    },
    async loadMoreCurrentChatMessages() {
      const loadedChatMessages = this.loadedMessagesByChat.find((chat) => chat.id == this.currentChat.chat.chat_id);
      this.loadingMore = true;
      //bail if all are loaded
      if (this.currentChat.chat.messages.length <= this.currentMessages.length) {
        this.loadingMore = false;
        return;
      }

      if (this.currentChat.chat.messages.length < loadedChatMessages.messages.length + (loadedChatMessages.messages.offSet + this.offsetBase)) {
        const newOffSet = this.offsetBase + loadedChatMessages.offSet;
        const newOffsetMessages = this.currentChat.chat.messages.slice(-newOffSet, loadedChatMessages.length - 1);
        const loadNewMessages = await this.$store.dispatch("chat/getMessagesOfDialogue", newOffsetMessages);
        loadedChatMessages.messages.unshift(...loadNewMessages);
        loadedChatMessages.offSet = newOffSet;
      } else {
        const newOffSet = this.offSetBase + loadedChatMessages.offSet;
        const start = parseInt(newOffSet);
        const end = parseInt(loadedChatMessages.offSet);
        const newOffsetMessages = this.currentChat.chat.messages.slice(-start, -end);

        const loadNewMessages = await this.$store.dispatch("chat/getMessagesOfDialogue", newOffsetMessages);
        loadedChatMessages.messages.unshift(...loadNewMessages);
        loadedChatMessages.offSet = newOffSet;
      }
      this.scrollToTop();
      this.loadingMore = false;
    },
    async refreshCurrentChat() {
      //const activeChat = this.activeChats.find((ac) => ac.chat_id == this.currentChat.chat.chat_id);
      //if (this.currentChat.chat.chat_id !== "NEW") this.currentChat.chat = activeChat;
      if (this.lockRefresh) return;
      this.refreshCurrentMessages()
      await this.loadNewChatMessages();
    },
    createNewChat(rec_id) {
      this.currentChat = {
        chatMe: this.user,
        chat: {
          chat_id: "NEW",
          messages: [],
          recipients: [rec_id],
        },
        active: true,
        newMessage: "",
      };
      this.currentMessages = [];
    },
    getRole(userId) {
      const user = this.allUsers.find((u) => u.id == userId);
      if (undefined == user) return;
      if (user.role == 1) {
        return this.getThemenOfUser(userId);
      }
      if (user.role == 3) return "Kunde";
      return "Default";
    },
    getThemenOfUser(id) {
      let result = [];
      try {
        for (let i = 0; i < this.themen.length; i++) {
          let ansp = this.themen[i].ansprechpartner;
          for (let a = 0; a < ansp.length; a++) {
            if (ansp[a].user_id.id == id) result.push(ansp[a].themen_id.name);
          }
        }
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim laden der Ansprechpartner Themen", this.toasts.failure);
      }
      if (!result.length) return "Infrabau Admin";
      return result.join(", ");
    },
    async createNewDialogue() {
      try {
        const responseDialogue = await this.$store.dispatch("chat/createDialogue");
        const relPayload = {
          chat: responseDialogue.data.id,
          recipients: [...this.currentChat.chat.recipients, this.user.id],
        };
        await this.$store.dispatch("chat/assignRecipientsToDialogue", relPayload);
        await this.$store.dispatch("chat/addDialogue", responseDialogue.data.id);
        return responseDialogue.data.id;
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Erstellen des Dialogs", this.toasts.failure);
      }
    },
    refreshCurrentMessages() {
      const chat = this.dialogues.find(ac => ac.id == this.currentChat.chat.chat_id);
      if(!chat) return;
      const messages = chat.messages.map(m => m.nachricht_id)
      this.currentChat.chat.messages = messages;
    },
    async sendMessage() {      
      if (!this.currentChat.newMessage.length) {
        this.$toasted.show("Nachrichtenfeld leer", this.toasts.failure);
        return;
      }

      const msg = this.currentChat.newMessage;

      const payload = {
        dialogueId: this.currentChat.chat.chat_id,
        message: this.currentChat.newMessage,
        sender: this.user.id,
      };

      try {
        this.currentChat.updating = true;
        await this.$store.dispatch("chat/sendMessage", payload);
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim senden der Nachricht.", this.toasts.failure);
      } finally {
        this.currentChat.updating = false;
        this.currentChat.newMessage = "";
      }

      const mailPayload = {
          mode: "customer",
          customer: this.currentChat.chat.kunde,
          message: msg,
          recipients: [this.currentChat.chat.kunde.email]
        }
        this.$store.dispatch("chat/sendChatMail", mailPayload);

      this.refreshCurrentChat();
      this.scrollToBottom();
    },
    scrollToBottom() {
      const chatContainer = this.$refs.current_chat_container;
      if (undefined !== chatContainer) {
        this.$nextTick(() => {
          chatContainer.scrollTop = chatContainer.scrollHeight;
        });
      }
    },
    scrollToTop() {
      const chatContainer = this.$refs.current_chat_container;
      if (undefined !== chatContainer) {
        this.$nextTick(() => {
          chatContainer.scrollTop = 5;
        });
      }
    },
    async assignUserToDialogue(user_id, dialog_id) {
      try {
        const subscribePayload = {
          dialog_id,
          user_id,
        };

        await this.$store.dispatch("chat/subscribeToDialogue", subscribePayload);
        await this.$store.dispatch("chat/getSingleDialogueData", dialog_id);
      } catch (err) {
        console.log(err);
        this.$toasted.show("Fehler beim Beitreten des Dialogs", this.toasts.failure);
      }
    },
    async removeUserFromDialogue(user_id, dialog_id) {
      try {
        const getDialoguePayload = {
          filter: {
            dialog_id: dialog_id,
            user_id: user_id,
          },
        };
        const getDialogueToUnsubscribe = await this.$directus.getItems("dialogue_users", getDialoguePayload);
        await this.$store.dispatch("chat/unsubscribeToDialogue", getDialogueToUnsubscribe.data[0].id);
      } catch (err) {
        console.log(err);
        this.$toasted.show("Fehler beim Verlassen des Dialogs", this.toasts.failure);
      }
    },
  },
  directives: {
    focus: {
      inserted: function(el) {
        el.focus();
      },
    },
  },
  scroll: {
    inserted: function(el, binding) {
      let f = function(evt) {
        if (binding.value(evt, el)) {
          window.removeEventListener("scroll", f);
        }
      };
      window.addEventListener("scroll", f);
    },
  },
};
</script>

<style>
.select-sub,
.remove-sub {
  color: #004f7d;
  font-size: 1.1em;
  font-weight: bold;
  padding: 5px;
  cursor: pointer;
}

.select-sub:hover,
.remove-sub:hover {
  background: lightgrey;
  transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -webkit-transition: all 0.3s ease-out;
}

.moderator-buttons {
  display: flex;
  margin-right: 20px;
}

.moderator-btn-icon {
  border: 1px solid #004f7d;
  border-radius: 75px;
  padding: 5px;
  cursor: pointer;
  margin-right: 5px;
}

.moderator-btn-icon:hover {
  color: white;
  background: #004f7d;
  transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -webkit-transition: all 0.3s ease-out;
}

.chat-header {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-self: flex-start;
}

.chat-header-avatars {
  width: 100%;
  display: flex;
  align-items: flex-start;
}

.chat-header-avatar {
  margin-right: 20px;
}

.loader-relative.load-more-loader {
  height: 50px;
}

.name {
  font-size: 0.8em;
}

.empty-chat-msg {
  position: relative;
  vertical-align: middle;
  font-size: 25px;
  margin: auto;
  top: 25%;
  left: 25%;
}

.tab-content {
  overflow: hidden;
}

.call-chat-sidebar .chat-box .chat-menu .tab-pane {
  padding: 0px;
}

.loader-container {
  position: relative;
  right: 25px;
  z-index: 999;
  bottom: -13px;
}
.first_chatbar {
  border-left: 0px solid #f6f7fb !important;
}
</style>

<style scoped>
.font-small {
  font-size: 10px !important;
}

.loader-fullscreen {
  width: 300px;
  margin: auto;
  top: 200px;
}

.loader-messages {
  text-align: center;
}

.loader {
  backdrop-filter: none;
  background: none;
}

.dialogue_overview {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
}

.subscriber_names {
  font-size: 0.7em;
  display: inline-block;
}

.subscriber_names div {
  margin-left: 5px;
}
</style>

<style scoped>
.seenByIcon {
  position: absolute;
  right: 10px;
}
.userBox {
  display: block;
  width: 100%;
  float: none;
  margin-bottom: 5px;
}

.userBoxCon {
  display: flex;
  flex-flow: column;
  padding: 10px;
}

.chatboxcon {
  border: 1px solid lightgrey;
  margin-bottom: 5px;
}

.search-container {
  overflow: hidden;
  margin-bottom: 10px;
  display: block;
  z-index: 999;
  background: white;
}

.headline-moderator-dialogues {
  border-bottom: 2px solid #004f7d;
  margin-bottom: 20px;
  text-align: center;
}

.search-container {
  margin-bottom: 20px;
  font-weight: bold;
}

.search-container input {
  border-radius: 10px;
  border: 1px solid lightgrey;
  padding: 2px;
}
</style>
